export const formatCurrency = (value: string | number): string => {
  return (+value).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });
};

export const formatQuantity = (value: string | number): string => {
  return (+value).toLocaleString('en-US');
};
